import React from 'react';

import { useState, useEffect } from 'react';

import { useQueryClient } from "react-query";

import makeStyles from '@mui/styles/makeStyles';

import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';
import { MotifResolutionCodes } from 'constants.js';
import { CausePrincipaleCodes } from 'constants.js';

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%',
        marginBottom: theme.spacing(1)
    },
}));



function DetailReparationDialogContent({ onChange, action }) {

    const classes = useStyles();

    const [detailReparation, setDetailReparation] = useState('');

    const queryClient = useQueryClient();

    useEffect(() => {
        onChange(null);
    }, [onChange]);


    useEffect(() => {


        const getActionData = () => {

            if (detailReparation === '') {
                return null;
            }

            let actionData =
            {
                code: action.code,
                details: []
            };


            actionData.details.push({
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.Texte,
                libelle: "Détail réparation",
                position: actionData.details.length,
                valeurString: detailReparation
            });

            return actionData;
        }

        const getClotureData = () => {

            if (detailReparation === '') {
                return null;
            }

            let clotureData = {
                motifResolutionCode: MotifResolutionCodes.ReparationEffectuee,
                causePrincipaleCode: CausePrincipaleCodes.Sav,
                causePrincipaleDetailId: 0,
                utilisateurFautifId: 0,
                commentaire: '',
                mailAutomatique: ''
            };

            return clotureData;
        }


        onChange(getActionData(), getClotureData());
    }, [action.code, onChange, detailReparation]);


    useEffect(() => {
        // componentDidMount events
        return () => {
            // componentWillUnmount events
            //console.log("componentWillUnmount");
                
            // Invalidation du cache react-query 
            queryClient.resetQueries("DetailReparation");
        }
    }, [queryClient]);

    return (
        <DialogContent>

            <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
            <Typography variant="body2" gutterBottom>{`Permettre l'édition du PDF Détail réparation`}</Typography>
            <Typography variant="body2" gutterBottom>{`Clôturer ce dossier après-vente (motif : Réparation effectuée - Cause principale : SAV)`}</Typography>

            <TextField className={classes.formControl} value={detailReparation} onChange={e => setDetailReparation(e.target.value)} variant={"filled"} label={"Détail réparation"} multiline />

        </DialogContent>
    );

}


export default DetailReparationDialogContent;